import cn from 'classnames';
import {useState} from "react";
import React from 'react';
const PrimaryButton = (props) => {
    const [isHover, setIsHover] = useState(false)
    const { className, style, hoverStyle, onClick, noUseHover, disabled=false } = props;
    let resultStyle = {...style};
    if (hoverStyle && isHover) {
        resultStyle = {...resultStyle, ...hoverStyle}
    }
    return (
        <button className={cn(' hover:duration-500 rounded-[100px]',{
            [className]: className,
            'lg:hover:bg-[#0A25FF]/80': !noUseHover && !disabled,
            'bg-[#0A25FF]': !disabled,
            'bg-[#0A25FF]/50': disabled,
            })} style={resultStyle} onClick={onClick} disabled={disabled}
            onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
            {props.children}
        </button>
    )
}

export {PrimaryButton}